export const storeList = [
    { key: 'WALTHAM', value: 1 },
    { key: 'FITCHBURG', value: 4 },
    { key: 'BROCKTON', value: 5 }
  ]